<template>
  <div>
    <v-list-item-group v-model="selectedComputed">
      <v-list-item v-for="(item, i) in filters" :key="i" :value="item.filter" link>
        <v-list-item-icon class="mr-3">
          <v-icon v-text="item.icon" :color="item.color"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="$t(item.text)"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="item.items.length > 0" class="justify-center">
          {{ item.items.length }}
        </v-list-item-action>
      </v-list-item>
    </v-list-item-group>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      required: true,
    },
    selectedFilter: {
      type: String,
      default: 'none',
    },
  },
  computed: {
    selectedComputed: {
      get() {
        return this.selectedFilter;
      },
      set(value) {
        this.$emit('update:selectedFilter', value);
      },
    },
  },
};
</script>
